import React from 'react';
import { costRows } from '../data/breakFreeContent';
export function CostSection() {
  return <section className="w-full bg-charcoal-900 py-12 sm:py-16" aria-labelledby="cost-title" data-id="element-32" data-mp="9bene1z40o2q">
      <div className="mx-auto max-w-3xl px-5" data-id="element-33" data-mp="4kog2j74ib5e">
        <h2 id="cost-title" className="text-center font-display text-[1.6rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-34" data-mp="4jdd2lli57fc">
          What does another year in the same cycle cost you?
        </h2>

        <ul className="mt-8 divide-y divide-charcoal-600 border-y border-charcoal-600" data-id="element-35" data-mp="3mqb7dwtrvxpn">
          {costRows.map(row => <li key={row.situation} className="flex flex-col gap-1 py-4 sm:flex-row sm:items-baseline sm:justify-between sm:gap-6" data-id="element-36" data-mp="3hsj4k7rlar6o">
              <span className="text-[11px] font-semibold uppercase tracking-[0.16em] text-ivory-100" data-id="element-37" data-mp="1g0wlqthuq2la">
                {row.situation}
              </span>
              <span className="text-[14px] leading-snug text-rose sm:text-right" data-id="element-38" data-mp="1az7959ezdgv3">
                → {row.result}
              </span>
            </li>)}
        </ul>

        <p className="mt-8 text-center font-display text-xl italic text-ivory-50 sm:text-2xl" data-id="element-39" data-mp="t9ycj3wsd9c7">
          The next chapter can be different.
        </p>
      </div>
    </section>;
}